// extracted by mini-css-extract-plugin
export default {"socialIcon":"social_socialIcon__fktXM"};